import { useParams } from "react-router-dom";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { PreparationReportsDashboardProvider } from "./components/preparation-dashboard/Preparation.provider";
import { PreparationsReportsDashboard } from "./components/preparation-dashboard";

export default function PreparationsReportsDetailsPage() {
  const { workOrderId } = useParams();

  return (
    <ToastProvider>
      <Dashboard>
        <PreparationReportsDashboardProvider workOrderId={workOrderId || ''}>
          <PreparationsReportsDashboard />
        </PreparationReportsDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}
